<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import moment from 'moment'
export default {
  name: 'insurance',
  props: ['studentInsurance'],
  data() {
    return {
      loading: false,
      errors: new Errors(),
      boyPhoto: require('@/assets/student-default-boy.png'),
      girlPhoto: require('@/assets/student-default-girl.png'),
      model: {
        studentId: null,
        benificiaries: []
      }
    }
  },
  computed: {
    showAge: () => dob => {
      if (dob === undefined || dob === null) return 'N/A'

      const dobDate = moment(dob, 'DD-MM-YYYY')
      const today = moment()
      const age = today.diff(dobDate, 'years')

      return age + ' years old'
    },
    genders() {
      return [
        {
          value: 'male',
          label: 'Male'
        },
        {
          value: 'female',
          label: 'Female'
        }
      ]
    },
    relationShip() {
      return [
        {
          value: 'father',
          label: 'Father'
        },
        {
          value: 'mother',
          label: 'Mother'
        }
      ]
    }
  },
  created() {
    this.onGetInsurance()
  },
  methods: {
    ...mapActions('studentProfile', ['saveInsurance', 'getInsurance']),
    onSourceChange(resource, index) {
      const modelBase = this.model.benificiaries[index]
      const parents = this.studentInsurance.parent

      switch (resource) {
        case 'father':
          modelBase.gender = 'male'
          if (parents) {
            modelBase.nameEn = parents.father_name_en
            modelBase.nameKh = parents.father_name_kh
            modelBase.phoneNumber = parents.father_phone1
            modelBase.relationShip = 'Father'
          }
          break
        case 'mother':
          modelBase.gender = 'female'
          if (parents) {
            modelBase.nameEn = parents.mother_name_en
            modelBase.nameKh = parents.mother_name_kh
            modelBase.phoneNumber = parents.mother_phone1
            modelBase.relationShip = 'Mother'
          }
          break
      }
    },
    generateUniqueId() {
      return Math.floor(Math.random() * 1000000) + 1
    },
    addBenificiary() {
      this.model.benificiaries.push({
        uniqueId: this.generateUniqueId(),
        id: 0,
        order: this.model.benificiaries.length + 1,
        nameEn: null,
        nameKh: null,
        phoneNumber: undefined,
        relationShip: undefined,
        gender: undefined,
        benficiaryProportion: 0,
        remark: null,
        deleted: false
      })
    },
    removeBenificiary(uniqueId) {
      const index = this.model.benificiaries.findIndex(
        item => item.uniqueId === uniqueId
      )
      this.model.benificiaries[index].deleted = true
      this.model.benificiaries
        .filter(item => item.deleted === false)
        .forEach((item, index) => {
          item.order = index + 1
        })
    },
    photoStudent() {
      if (this.studentInsurance.photo) {
        return this.studentInsurance.photo
      }

      return this.studentInsurance.gender == 'Male'
        ? this.boyPhoto
        : this.girlPhoto
    },
    onError() {
      event
        ? (event.target.src =
            this.studentInsurance.gender == 'Male'
              ? this.boyPhoto
              : this.girlPhoto)
        : ''
    },
    onSave() {
      this.loading = true
      this.saveInsurance(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('close', false)
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    onCloseModal() {
      this.$emit('close', false)
    },
    async onGetInsurance() {
      this.loading = true
      const studentId = this.studentInsurance.student_id
      return this.getInsurance(studentId)
        .then(({ data }) => {
          this.model.studentId = this.studentInsurance.student_id
          if (data.length) {
            data.forEach(item => {
              this.createRecord({
                uniqueId: this.generateUniqueId(),
                id: item.id,
                order: item.order,
                nameEn: item.name_en,
                nameKh: item.name_kh,
                phoneNumber: item.phone_number,
                relationShip: item.relationship,
                gender: item.gender,
                benficiaryProportion: item.benificiary_pro,
                remark: item.remark,
                deleted: false
              })
            })
          } else {
            this.createRecord({
              uniqueId: this.generateUniqueId(),
              id: 0,
              order: 1,
              nameEn: null,
              nameKh: null,
              phoneNumber: undefined,
              relationShip: undefined,
              gender: undefined,
              benficiaryProportion: 0,
              remark: null,
              deleted: false
            })
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    createRecord(row) {
      this.model.benificiaries.push(row)
    }
  }
}
</script>

<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-flex ts-space-x-5 ts-bg-gray-100 ts-p-3 ts-rounded-md">
        <!-- Photo Section -->
        <div class="ts-flex ts-flex-col ts-items-center">
          <div
            class="ts-w-24 ts-h-32 ts-rounded-md ts-overflow-hidden ts-border-2 ts-border-white ts-shadow-md"
          >
            <img
              class="ts-w-24 ts-h-32 ts-object-cover"
              v-lazy="{
                src: photoStudent(),
                error: onError,
                loading: require('@/assets/Rolling-1s-200px_2.svg')
              }"
            />
          </div>
          <div
            class="ts-bg-blue-800 ts-text-white ts-px-3 ts-py-1 ts-rounded-b-lg ts-text-xs ts-font-bold ts-mt-1 ts-shadow-md"
          >
            ID: {{ studentInsurance ? studentInsurance.card_number : 'N/A' }}
          </div>
        </div>

        <!-- Information Section -->
        <div class="ts-bg-opacity-20 ts-p-4 ts-rounded-lg ts-flex-grow">
          <div class="ts-mb-1">
            <div class="ts-text-xs ts-opacity-75">
              {{ $t('studentprofile.nameKh') }}:
            </div>
            <p class="ts-font-bold ts-text-lg">
              {{ studentInsurance.full_name_kh }}
            </p>
          </div>
          <div class="ts-mb-1">
            <div class="ts-text-xs ts-opacity-75">
              {{ $t('studentprofile.nameEn') }}:
            </div>
            <p class="ts-font-bold">
              {{ studentInsurance.full_name_en || 'Unknow' }}
            </p>
          </div>
          <div class="ts-flex ts-space-x-3 ts-mt-2">
            <div>
              <div class="ts-text-xs ts-opacity-75">
                {{ $t('studentprofile.dob') }}:
              </div>
              <p>{{ studentInsurance.date_of_birth || 'N/A' }}</p>
              <p>
                <small
                  ><i>{{ showAge(studentInsurance.date_of_birth) }}</i></small
                >
              </p>
            </div>
            <div>
              <div class="ts-text-xs ts-opacity-75">
                {{ $t('studentprofile.gender') }}:
              </div>
              <p>{{ studentInsurance.gender || 'Unknow' }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="ts-flex ts-justify-between ts-items-end">
        <h1 class="ts-mt-6">Parent/Legal Guardian's Information</h1>
      </div>
      <div
        v-for="(b, index) in model.benificiaries.filter(
          i => i.deleted === false
        )"
        :key="index"
        class="ts-border ts-p-2 ts-rounded-md ts-mt-10 ts-relative"
      >
        <a-popconfirm
          :title="$t('are_you_sure_to_delete')"
          placement="left"
          @confirm="removeBenificiary(b.uniqueId)"
          :ok-text="$t('yes')"
          :cancel-text="$t('no')"
        >
          <button
            class="ts-absolute ts-right-0 ts--mr-3 ts-mt-3 ts-h-6 ts-w-6 ts-bg-gray-500
             ts-text-white ts-flex ts-place-items-center ts-justify-center
              ts-z-10 ts-top-0 ts-rounded-full focus:ts-outline-none hover:ts-bg-red-500 ts-duration-300
            "
            style="right: -1px; top: -25px;"
          >
            <i class="fas fa-times"></i>
          </button>
        </a-popconfirm>
        <a-select
          :options="relationShip"
          placeholder="sources"
          class="ts-w-full"
          @change="e => onSourceChange(e, index)"
        ></a-select>
        <div class="row ts-mt-2">
          <div class="col-md-6">
            <div class="ts-text-xs ts-opacity-75">
              <span
                >{{ $t('studentprofile.nameKh') }}
                <span class="ts-text-red-600">*</span></span
              >
            </div>
            <a-input v-model.trim="b.nameKh"></a-input>
            <div
              class="ts-text-red-500"
              v-if="errors.has(`benificiaries.${index}.nameKh`)"
            >
              {{ errors.first(`benificiaries.${index}.nameKh`) }}
            </div>
          </div>
          <div class="col-md-6">
            <div class="ts-text-xs ts-opacity-75">
              {{ $t('studentprofile.nameEn') }}
              <span class="ts-text-red-600">*</span>
            </div>
            <a-input v-model.trim="b.nameEn"></a-input>
            <div
              class="ts-text-red-500"
              v-if="errors.has(`benificiaries.${index}.nameEn`)"
            >
              {{ errors.first(`benificiaries.${index}.nameEn`) }}
            </div>
          </div>
        </div>
        <div class="row ts-mt-2">
          <div class="col-md-6">
            <div class="ts-text-xs ts-opacity-75">
              <span
                >{{ $t('studentprofile.phoneNumber') }}
                <span class="ts-text-red-600">*</span></span
              >
            </div>
            <a-input v-model.trim="b.phoneNumber"></a-input>
            <div
              class="ts-text-red-500"
              v-if="errors.has(`benificiaries.${index}.phoneNumber`)"
            >
              {{ errors.first(`benificiaries.${index}.phoneNumber`) }}
            </div>
          </div>
          <div class="col-md-6">
            <div class="ts-text-xs ts-opacity-75">
              {{ $t('studentprofile.gender') }}
              <span class="ts-text-red-600">*</span>
            </div>
            <a-select
              v-model="b.gender"
              class="ts-w-full"
              :options="genders"
            ></a-select>
            <div
              class="ts-text-red-500"
              v-if="errors.has(`benificiaries.${index}.gender`)"
            >
              {{ errors.first(`benificiaries.${index}.gender`) }}
            </div>
          </div>
        </div>
        <div class="row ts-mt-2">
          <div class="col-md-6">
            <div class="ts-text-xs ts-opacity-75">
              <span
                >{{ $t('studentprofile.relationshipWithStudent') }}
                <span class="ts-text-red-600">*</span></span
              >
            </div>
            <a-input
              v-model.trim="b.relationShip"
              placeholder="Parents,Other"
            ></a-input>
            <div
              class="ts-text-red-500"
              v-if="errors.has(`benificiaries.${index}.relationShip`)"
            >
              {{ errors.first(`benificiaries.${index}.relationShip`) }}
            </div>
          </div>
          <div class="col-md-6">
            <div class="ts-text-xs ts-opacity-75">
              {{ $t('studentprofile.benficiaryProportion') }}
              <span class="ts-text-red-600">*</span>
            </div>
            <a-input
              v-model="b.benficiaryProportion"
              type="number"
              class="ts-w-full"
            ></a-input>
            <div
              class="ts-text-red-500"
              v-if="errors.has(`benificiaries.${index}.benficiaryProportion`)"
            >
              {{ errors.first(`benificiaries.${index}.benficiaryProportion`) }}
            </div>
          </div>
        </div>
        <div class="row ts-mt-2">
          <div class="col-md-12">
            <div class="ts-text-xs ts-opacity-75">
              <span>{{ $t('studentprofile.remark') }}</span>
            </div>
            <a-input v-model="b.remark"></a-input>
          </div>
        </div>
      </div>
      <button
        @click.prevent="addBenificiary"
        class=" ts-w-full  ts-bg-blue-100 ts-py-2 focus:ts-outline-none ts-mt-3 ts-text-blue-500 ts-font-bold ts-flex ts-items-center ts-justify-center ts-rounded-md"
      >
        <i class="fas fa-plus ts-mr-2"></i>
        {{ $t('studentprofile.newLegal') }}
      </button>
      <div class="row ts-mt-3">
        <div class="col-md-12 ts-flex ts-justify-end ts-space-x-2">
          <ts-button @click.prevent="onCloseModal">{{
            $t('cancel')
          }}</ts-button>
          <ts-button
            v-if="model.benificiaries.length"
            @click.prevent="onSave"
            color="primary"
            >{{ $t('save') }}</ts-button
          >
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>
